import "../stylesheets/application.scss";
import { Turbo } from "@hotwired/turbo-rails"
import "../controllers"

// Disable Turbo Drive to prevent conflicts with jQuery UJS
Turbo.session.drive = false

require.context("../images", true);

/**
 * Import jQuery on a global var first
 */

window.$ = window.jQuery = require("jquery");

/**
 * Add onmount, which we will use for idempotent binding behavior to dom items
 */

$.onmount = require("onmount");

/**
 * Add libraries here
 */

require("bootstrap");
require("bootstrap-notify");
require("jquery-ujs");
require("nouislider");

/**
 * Add behavior javascripts
 */

require("./behaviors/autocomplete-select");
require("./behaviors/carousel");
require("./behaviors/change-input");
require("./behaviors/clipboard");
require("./behaviors/donation-terms");
require("./behaviors/cookie-consent");
require("./behaviors/countdown");
require("./behaviors/custom-file-input");
require("./behaviors/donutchart");
require("./behaviors/expandable");
require("./behaviors/file-size-limit");
require("./behaviors/hide-target");
require("./behaviors/input-slider");
require("./behaviors/interest-rate-slider");
require("./behaviors/investment-planner");
require("./behaviors/lazyload");
require("./behaviors/maturity-slider");
require("./behaviors/mobile-menu");
require("./behaviors/notification");
require("./behaviors/open-lightbox");
require("./behaviors/payment-method-selection");
require("./behaviors/popover");
require("./behaviors/scroll-to");
require("./behaviors/searchbox");
require("./behaviors/select-amount");
require("./behaviors/select-amount-slider");
require("./behaviors/show-target");
require("./behaviors/stacked-bar-chart");
require("./behaviors/tabs");
require("./behaviors/toggle-input-fields");
require("./behaviors/toggle-target");
require("./behaviors/toggle-warning-on-select");
require("./behaviors/tooltip");
require("./behaviors/track");
require("./behaviors/update-payment-fees");
require("./behaviors/update-project-counts");
require("./behaviors/update-financial-dashboard");
require("./behaviors/check-coupon");
require("./behaviors/xhr-form");
require("./behaviors/sticky");
require("./behaviors/submit-on-change");
require("./behaviors/ribbon-toggle");

/**
 * Add modules here
 */

require("./modules/jquery-match-height");

require("./behaviors/bank_accounts/bank_account_form");
require("./behaviors/bank_accounts/poll_status");
require("./behaviors/bank_accounts/toggle_sepa_mandate");

document.addEventListener("DOMContentLoaded", function() {
  $.onmount();
});
